import HeaderTwo from "../../components/header/HeaderTwo";
import Footer from "../../components/footer/Footer";
import Breadcrumb from "./Breadcrumb";
import AboutInner from "./AboutInner";
import LatestMatch from "./LatestMatch";
import WhatNext from "./what-next";
import OurDeployments from "./out-deployments";
import HowCanYouEarn from "./how-can-you-earn";
import ReleaseGame from "../aboutpage/singlegame/ReleaseGame";
import BlogArea from "../../components/index/indextwo/BlogArea";

export default function BusinessModelMudgames() {
  return (
    <>
      <HeaderTwo />
      <main>
        <Breadcrumb />
        <AboutInner />
        <LatestMatch />
        <HowCanYouEarn />
        <WhatNext />
        <BlogArea />
        <OurDeployments />
        <ReleaseGame />
      </main>
      <Footer />
    </>
  );
}
